import React from 'react'
import { css } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import { CustomColumnHeaderRenderer } from '../../legacy-design-system/grid'
import {
  DateRangePicker,
  DateRangePickerDropdown,
  DateRangeOption
} from '../../legacy-design-system/date-picker'
import { DateRange } from '../../legacy-design-system/date-picker/shared'
import { VulnerabilityDateField } from './shared'
import { Radio } from '@contrast-security-inc/design-system-inputs'
import { theme } from '@contrast-security-inc/design-system-foundations'

export interface LastDetectedColumnArgs {
  readonly dateRange?: DateRange
  readonly dateRangeOption?: DateRangeOption
  readonly onSetCustomDateRange: (dateRange: DateRange) => void
  readonly onSetDateRangeOption: (dateRangeOption: DateRangeOption) => void
  readonly onClearDateRange: () => void
  readonly dateField?: VulnerabilityDateField
  readonly onSetDateField: (dateField: VulnerabilityDateField) => void
}

export function getLastDetectedHeaderRenderer<
  TAggregationCategory extends string
>({
  dateRange,
  dateRangeOption,
  onSetCustomDateRange,
  onSetDateRangeOption,
  onClearDateRange,
  dateField,
  onSetDateField
}: LastDetectedColumnArgs): CustomColumnHeaderRenderer<TAggregationCategory> {
  return ({ renderContent }) => {
    return (
      <DateRangePickerDropdown
        selectedDateRange={dateRange}
        selectedOption={dateRangeOption}
        onDateRangeOptionSelect={onSetDateRangeOption}
        onCustomDateRangeSelect={onSetCustomDateRange}
        renderToggle={({ getToggleButtonProps, isOpen, selectedItem }) => {
          return (
            <div {...getToggleButtonProps()}>
              {renderContent({
                isClickable: true,
                isOpen,
                isFilterable: true,
                isFiltered:
                  selectedItem !== undefined && dateRange !== undefined,
                onClear: onClearDateRange
              })}
            </div>
          )
        }}
        renderDateRangePicker={(props) => <DateRangePicker {...props} />}
        renderAdditionalMenuContent={() => {
          return (
            <React.Fragment>
              <div
                className={css`
                  display: flex;
                  flex-direction: column;
                  padding: 4px 10px;
                `}
              >
                <FormattedMessage id="title_firstDetected_vulnerability">
                  {(label) => {
                    return (
                      <Radio
                        label={label as any}
                        onChange={() => onSetDateField('FIRST')}
                        isChecked={dateField === 'FIRST'}
                      />
                    )
                  }}
                </FormattedMessage>
                <FormattedMessage id="title_vulnerabilities_lastDetected_vulnerability">
                  {(label) => {
                    return (
                      <Radio
                        label={label as any}
                        onChange={() => onSetDateField('LAST')}
                        isChecked={dateField === 'LAST'}
                      />
                    )
                  }}
                </FormattedMessage>
              </div>
              <hr
                className={css`
                  margin: 0;
                  border: 0;
                  margin-top: 5px;
                  padding-bottom: 5px;
                  border-top: 1px solid ${theme.color.neutral30};
                `}
              />
            </React.Fragment>
          )
        }}
      />
    )
  }
}
